export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6752.986c7c73.jpg";